
export interface Label {
  labelType: string,
  description: string,
  id: number,
  selectableScenarios: SelectableScenario[],
  preloadableScenarios: PreloadableScenario[]
}

export interface SelectableScenario {
  scenarioId: string,
  scenarioName: string,
  itemCount: number,
  position: number,
  iconName: string,
  description: string,
  key: string,
  id: number
}

export type PreloadableScenario = SelectableScenario

export interface PreloadableLabels {
  labelId: number,
  itemCounts: ItemCount[]
}

export interface ItemCount {
  itemCount: number,
  scenarioId: string
}

export interface PreloadableCategories    {
  name: string,
  description: string,
  id: number,
  labelCounts?: PreloadableLabels[]
}
